import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import SEARCH_INTEGRATION_JOBS from './searchIntegrationJobs.gql';

import type { HivebriteSegmentType } from '../types.ts';

interface IntegrationJobMetadata {
  audience_id: string;
  list_ids: string[];
  list_type: HivebriteSegmentType;
  progress_details?: Record<string, any>;
}

export interface IntegrationJob {
  completedAt: string;
  createdAt: string;
  displayName: string;
  jobRunId: string;
  metadata?: IntegrationJobMetadata;
  progress: number;
  status: string;
}

interface SearchIntegrationJobsResult {
  searchIntegrationJobs: {
    result: IntegrationJob[];
  };
}

export function searchIntegrationJobs(
  workspaceId: ObjectId,
  audienceId?: string,
  status?: string,
) {
  return gqlOperation<SearchIntegrationJobsResult>(SEARCH_INTEGRATION_JOBS, {
    audienceId,
    status,
    workspaceId,
  })
    .then((data) => {
      if (!data) throw data;
      return data.searchIntegrationJobs;
    });
}
